import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { I18nProvider } from '@/lib/i18n';
import { BrandingProvider } from '@/lib/branding';
import { AppShell, FullScreenLayout } from '@/components/AppShell';
import { Toaster } from '@/components/ui/sonner';

import Dashboard from '@/pages/Dashboard';
import Pos from '@/pages/Pos';
import Kds from '@/pages/Kds';
import FloorPlan from '@/pages/FloorPlan';
import Reservations from '@/pages/Reservations';
import Menu from '@/pages/Menu';
import Recipes from '@/pages/Recipes';
import Inventory from '@/pages/Inventory';
import Suppliers from '@/pages/Suppliers';
import Expenses from '@/pages/Expenses';
import Income from '@/pages/Income';
import Invoices from '@/pages/Invoices';
import Reports from '@/pages/Reports';
import Pgc from '@/pages/Pgc';
import Settings from '@/pages/Settings';
import Locations from '@/pages/Locations';
import PublicReserve from '@/pages/PublicReserve';

function withShell(Component, fullBleed = false) {
  return (
    <AppShell fullBleed={fullBleed}>
      <Component />
    </AppShell>
  );
}

function App() {
  return (
    <I18nProvider>
      <BrandingProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={withShell(Dashboard)} />
              <Route path="/pos" element={withShell(Pos, true)} />
              <Route path="/floor-plan" element={withShell(FloorPlan, true)} />
              <Route path="/reservations" element={withShell(Reservations)} />
              <Route path="/kds" element={
                <FullScreenLayout>
                  <Kds />
                </FullScreenLayout>
              } />
              <Route path="/menu" element={withShell(Menu)} />
              <Route path="/recipes" element={withShell(Recipes)} />
              <Route path="/inventory" element={withShell(Inventory)} />
              <Route path="/suppliers" element={withShell(Suppliers)} />
              <Route path="/expenses" element={withShell(Expenses)} />
              <Route path="/income" element={withShell(Income)} />
              <Route path="/invoices" element={withShell(Invoices)} />
              <Route path="/reports" element={withShell(Reports)} />
              <Route path="/pgc" element={withShell(Pgc)} />
              <Route path="/locations" element={withShell(Locations)} />
              <Route path="/settings" element={withShell(Settings)} />
              <Route path="/reservar" element={<PublicReserve />} />
              <Route path="/reserve" element={<PublicReserve />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster richColors position="top-right" />
        </div>
      </BrandingProvider>
    </I18nProvider>
  );
}

export default App;
